export const fileUpdateIconStatesData = [
    {
      state: "loading",
      icon: "sync",
      loading: true,
      message : "Procesando factura",
      color: "black",
      size: "large"
    },
    {
      state: "success",
      icon: "check circle outline",
      loading: false,
      message : "Factura procesada y enviada por mail al paciente",
      color: "green",
      size: "large"
    },
    {
      state: "error",
      icon: "exclamation",
      loading: false,
      message : "Error al procesar la factura",
      color: "red",
      size: "large"
    }
  ]